import configuration from "@/configuration";
import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

const Wrapper = ({ children }: { children: ReactNode }) => {
    const navigate = useNavigate();

    const onRedirectCallback = (appState: AppState | undefined) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    return (
        <Auth0Provider
            domain={configuration.auth.domain}
            clientId={configuration.auth.clientId}
            authorizationParams={{
                audience: configuration.auth.audience,
                scope: configuration.auth.scope,
                redirect_uri: `${window.location.origin}`,
            }}
            cacheLocation="localstorage"
            onRedirectCallback={onRedirectCallback}
        >
            {children}
        </Auth0Provider>
    );
};

export default Wrapper;
